var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuPostDraft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37.11 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.45,1.7a5.43,5.43,0,0,0-6.7,0V1.27A1.27,1.27,0,0,0,35.48,0H19.64a1.26,1.26,0,0,0-.89.37l-9.94,10a1.26,1.26,0,0,0-.37.9V30.73A1.27,1.27,0,0,0,9.71,32H35.48a1.27,1.27,0,0,0,1.27-1.27V19.14L44.4,9.32A5.44,5.44,0,0,0,43.45,1.7ZM19.29,3.43v7.42H11.9Zm14.92,26H11V13.39h9.58a1.27,1.27,0,0,0,1.27-1.27V2.54H34.21v2.2L25.58,15.82a.8.8,0,0,0-.16.42l-.74,8.5a.81.81,0,0,0,.3.69.79.79,0,0,0,.74.12l8.06-2.8a.78.78,0,0,0,.36-.26l.07-.09Zm-2-7.85-5.9,2.05.54-6.22ZM43.15,8.35l-.28.36L36.8,4l.28-.37a3.85,3.85,0,0,1,6.07,4.73Z",
    transform: "translate(-8.44)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuPostDraft);
export default __webpack_public_path__ + "static/media/menu-post-draft.b6e946d3.svg";
export { ForwardRef as ReactComponent };